The amount the candidate expects to receive.
